import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'react-bootstrap'

import { isExcelFile } from 'helpers'
import * as fromActions from 'store/actions/externalCourses.action'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { UploadFileV2 } from 'components/ui/modals/UploadFile/V2'

import styles from './UploadButton.module.scss'

const REQUIREMENTS = ['courses', 'participants', 'optional_data']

const UploadButton: React.FC = () => {
  const [error, setError] = React.useState<React.ReactNode>(null)

  const { t } = useTranslation()
  const tUpload = useTranslationRankmi({
    prefix: 'administration.externalCourses.list.upload',
  })
  const dispatch = useDispatch()

  const [show, setShow] = useState(false)

  const handleClose = () => {
    setShow(false)
    setError(null)
  }

  const handleShow = () => setShow(true)

  const handleFileUpload = (file: File) => {
    setError(null)

    if (!isExcelFile(file)) {
      setTimeout(() => {
        setError(<>{tUpload('modal.error')}</>)
      }, 500)

      return
    }

    dispatch(fromActions.Actions.uploadFile(file))
    setShow(false)
  }

  return (
    <>
      <Dropdown.Item onClick={handleShow}>{tUpload('label')}</Dropdown.Item>
      {show && (
        <UploadFileV2
          title={tUpload('modal.title')}
          labels={{
            close: t('commons.buttons.close'),
            inputPlaceholder: tUpload('modal.v2.inputPlaceholder'),
          }}
          template={{
            link: 'https://rankmi-lms-prod.s3.amazonaws.com/templates/plantilla-cursos-externos.xlsx',
            label: tUpload('modal.template'),
          }}
          help={{
            label: tUpload('modal.v2.help.label'),
            link: 'https://rankmi.odoo.com/knowledge/article/2625',
          }}
          onClose={handleClose}
          onUpload={handleFileUpload}
          error={error}
        >
          <p className={styles.requirementsTitle}>
            {tUpload('modal.v2.requirements.title')}:
          </p>
          <ul className={styles.requirementsList}>
            {REQUIREMENTS.map((requirement) => {
              const translationKey = `modal.v2.requirements.requirement.${requirement}`
              const title = tUpload(`${translationKey}.title`)
              const description = tUpload(`${translationKey}.description`)

              return (
                <li>
                  <b>{title}</b>: {description}
                </li>
              )
            })}
          </ul>
        </UploadFileV2>
      )}
    </>
  )
}

export default UploadButton
